
import { supabase } from "@/integrations/supabase/client";
import { v4 as uuidv4 } from "uuid";

interface UploadResult {
  publicUrl: string | null;
  error: Error | null;
}

export const uploadMediaFile = async (file: File): Promise<UploadResult> => {
  try {
    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      return {
        publicUrl: null,
        error: new Error("Image must be smaller than 5MB")
      };
    }

    // Create a unique file name
    const fileExt = file.name.split('.').pop();
    const fileName = `${uuidv4()}.${fileExt}`;
    const filePath = `${fileName}`;

    console.log("Attempting to upload media file:", { fileName, fileExt, filePath });

    // Upload file to Supabase Storage
    const { data, error } = await supabase.storage
      .from('media')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: true
      });

    if (error) {
      console.error("Media upload error:", error);
      return {
        publicUrl: null,
        error
      };
    }

    console.log("Media upload successful:", data);

    // Get the public URL for the uploaded file
    const { data: { publicUrl } } = supabase.storage
      .from('media')
      .getPublicUrl(filePath);

    console.log("Generated media public URL:", publicUrl);
    
    return {
      publicUrl,
      error: null
    };
  } catch (error) {
    console.error("Error uploading media file:", error);
    return {
      publicUrl: null,
      error: error instanceof Error ? error : new Error("Unknown error occurred")
    };
  }
};
